$(document).ready(function () { // eslint-disable-line no-undef
  var qsRegex
  var buttonFilter

  var $grid = $('.grid').imagesLoaded(function () { // eslint-disable-line no-undef
    $grid.isotope({
      itemSelector: '.grid-item',
      layoutMode: 'fitRows',
      filter: function () {
        var $this = $(this) // eslint-disable-line no-undef
        var searchResult = qsRegex ? $this.text().match(qsRegex) : true
        var buttonResult = buttonFilter ? $this.is(buttonFilter) : true
        return searchResult && buttonResult
      }
    })
    var iso = $('.grid').data('isotope') // eslint-disable-line no-undef
    $('#counter').html(iso.filteredItems.length + ' vin' + (iso.filteredItems.length > 1 ? 's' : '')) // eslint-disable-line no-undef
  })

  $('#filters').on('click', 'button', function () { // eslint-disable-line no-undef
    buttonFilter = $(this).attr('data-filter') // eslint-disable-line no-undef
    $grid.isotope()
    var iso = $('.grid').data('isotope') // eslint-disable-line no-undef
    $('#counter').html(iso.filteredItems.length + ' vin' + (iso.filteredItems.length > 1 ? 's' : '')) // eslint-disable-line no-undef
  })

  var $quicksearch = $('.quick-search').keyup(debounce(function () { // eslint-disable-line no-undef
    qsRegex = new RegExp($quicksearch.val(), 'gi')
    $grid.isotope()
    var iso = $('.grid').data('isotope') // eslint-disable-line no-undef
    $('#counter').html(iso.filteredItems.length + ' vin' + (iso.filteredItems.length > 1 ? 's' : '')) // eslint-disable-line no-undef
  }))

  $('.quick-search').keypress(function (event) { // eslint-disable-line no-undef
    if (event.which === 13) {
      event.preventDefault()
    }
  })

  $('#formSearch').submit(function (event) { // eslint-disable-line no-undef
    event.preventDefault()
  })

  $('#formSearch').on('reset', function () { // eslint-disable-line no-undef
    $('#btnClearSearch').click() // eslint-disable-line no-undef
  })

  $('#btnClearSearch').on('click', function (event) { // eslint-disable-line no-undef
    event.preventDefault()
    $('.quick-search').val('') // eslint-disable-line no-undef
    qsRegex = new RegExp('', 'gi')
    $grid.isotope()
    var iso = $('.grid').data('isotope') // eslint-disable-line no-undef
    $('#counter').html(iso.filteredItems.length + ' vin' + (iso.filteredItems.length > 1 ? 's' : '')) // eslint-disable-line no-undef
  })

  $('.button-group').each(function (i, buttonGroup) { // eslint-disable-line no-undef
    var $buttonGroup = $(buttonGroup) // eslint-disable-line no-undef
    $buttonGroup.on('click', 'button', function () {
      $buttonGroup.find('.is-checked').removeClass('is-checked special')
      $(this).addClass('is-checked special') // eslint-disable-line no-undef
    })
  })

  // debounce so filtering doesn't happen every millisecond
  function debounce (fn, threshold) {
    var timeout
    threshold = threshold || 100
    return function debounced () {
      clearTimeout(timeout)
      var args = arguments
      var _this = this
      function delayed () {
        fn.apply(_this, args)
      }
      timeout = setTimeout(delayed, threshold)
    }
  }
})



// WEBPACK FOOTER //
// ./assets/js/isotope.js